import './StatsContent.css';
import type { CharacterStats } from '../../../../domain/CharacterStats';
import controlIcon from '../../components/atomic/icons/stat_icons/control_icon.png';
import powerIcon from '../../components/atomic/icons/stat_icons/power_icon.png';
import speedIcon from '../../components/atomic/icons/stat_icons/speed_icon.png';
import { StatLabelText } from './StatLabelText';
import { StatScaleBar } from './StatScaleBar';
import { StatValueText } from './StatValueText';
import statIconBackground from './stat_icon_background.png';
import statValueBackground from './stat_value_background.png';

export type { CharacterStats };

export type StatsContentProps = {
  stats: CharacterStats;
};

const STAT_ROWS = [
  {
    id: 'speed',
    label: 'Скорость',
    labelWidth: 195,
    icon: speedIcon,
    iconClassName: 'stats-content__icon--speed',
  },
  {
    id: 'control',
    label: 'Управление',
    labelWidth: 251,
    icon: controlIcon,
    iconClassName: 'stats-content__icon--control',
  },
  {
    id: 'power',
    label: 'Мощь',
    labelWidth: 123,
    icon: powerIcon,
    iconClassName: 'stats-content__icon--power',
  },
] as const;

/** Figma Group 1321317891 (121:21272) — character speed / control / power. */
export function StatsContent({ stats }: StatsContentProps) {
  const values = {
    speed: stats.speed,
    control: stats.control,
    power: stats.power,
  };

  return (
    <div className="stats-content" aria-hidden>
      {STAT_ROWS.map((row) => {
        const value = values[row.id];

        return (
          <div key={row.id} className={`stats-content__row stats-content__row--${row.id}`}>
            <div className="stats-content__icon-wrap">
              <img
                className="stats-content__icon-background"
                src={statIconBackground}
                alt=""
                draggable={false}
              />
              <img
                className={['stats-content__icon', row.iconClassName]
                  .filter(Boolean)
                  .join(' ')}
                src={row.icon}
                alt=""
                draggable={false}
              />
            </div>

            <StatLabelText
              className="stats-content__label"
              text={row.label}
              width={row.labelWidth}
            />

            <StatScaleBar
              className="stats-content__scale"
              value={value}
            />

            <div className="stats-content__value-wrap">
              <img
                className="stats-content__value-background"
                src={statValueBackground}
                alt=""
                draggable={false}
              />
              <StatValueText
                className="stats-content__value"
                value={value}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
